module.exports = __webpack_public_path__ + "img/zimmer-frei.5149ef29.jpg";